module.exports = __webpack_public_path__ + "img/app-store.e3dfbb50.webp";